module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="dd-contact-list">\n	<div>\n	';
 if ( templates.length != 0){;
__p += '\n	<a  class="add-template pull-right" href="//dc.console.aliyun.com/next/index?#/info-template/InfoTemplate" target="_blank">创建新的信息模板</a>\n	';
};
__p += '\n	以下为您曾使用过的域名信息，您可以直接选择使用：\n	<div style="color:orange;">1、按照ICANN政策要求，域名持有人Email邮箱必须真实准确，必须完成邮箱真实性验证的模板才能正常使用。\n	<a href="https://help.aliyun.com/document_detail/62839.html" target="_blank">了解更多</a>\n	</div>\n	';
 if ( config.filterStatus){;
__p += '\n		<div style="color:orange;">2、必须选择已经完成实名的信息模板。</div>\n	';
};
__p += '\n	</div>\n		<table  cellpadding="0" cellspacing="0"  class="list-table">\n			<tbody class="contact-template-rows">\n			';
 if (!templates){;
__p += '\n			<tr class="wait">\n				<td align="center" colspan="5" >\n					<img src="//img.alicdn.com/tps/TB1pXLPLFXXXXa7XXXXXXXXXXXX-200-200.gif">\n				</td>\n			</tr>\n			';
}else{;
__p += '\n				';
 if (!foldClose && selectTemplate) {;
__p += '\n				<tr>\n					<td class="col-1" style="width:30px;">\n						<input type="radio" name="templateRadio"\n						class="template-id" value="' +
((__t = (selectTemplate.registrantProfileId)) == null ? '' : __t) +
'"\n						';
if (selectTemplate) {;
__p += ' checked ';
};
__p += '\n						>\n					</td>\n					<td>' +
((__t = (selectTemplate.zhRegistrantOrganization)) == null ? '' : __t) +
'</td>\n					<td style="display: ' +
((__t = (config['smallStyle']&&'none')) == null ? '' : __t) +
'">' +
((__t = (selectTemplate.registrantOrganization)) == null ? '' : __t) +
'</td>\n					<td>' +
((__t = (selectTemplate.email)) == null ? '' : __t) +
'</td>\n					';
if(!(config['auditStatus'] === false)){;
__p += '\n						<td>\n							' +
((__t = (({FAILED:'审核失败',SUCCEED:'已实名认证',NONAUDIT:'未实名认证',AUDITING:'审核中'})[(selectTemplate.realNameStatus === undefined? "NONAUDIT" : selectTemplate.realNameStatus)] || '')) == null ? '' : __t) +
'\n						</td>\n					';
};
__p += '\n					<td><a   class="view-detail" data-id="' +
((__t = (selectTemplate.registrantProfileId)) == null ? '' : __t) +
'">详情</a></td>\n				</tr>\n				';
} else {;
__p += '\n				';
 for(var i=0; i<templates.length; i++) {;
__p += '\n				';
if (!foldClose && i>=1) break;;
__p += '\n				<tr style="color:' +
((__t = ( templates[i].emailVerificationStatus?'inherit':'gray' )) == null ? '' : __t) +
'">\n					<td class="col-1" style="width:30px;">\n						<input type="radio" name="templateRadio" class="template-id" value="' +
((__t = (templates[i].registrantProfileId)) == null ? '' : __t) +
'"\n						' +
((__t = ( templates[i].emailVerificationStatus?'':'disabled' )) == null ? '' : __t) +
'\n						';
if (selectTemplate && selectTemplate.registrantProfileId==templates[i].registrantProfileId) {;
__p += ' checked ';
};
__p += '\n					></td>\n					<td>' +
((__t = (templates[i].zhRegistrantOrganization)) == null ? '' : __t) +
'</td>\n					<td style="display: ' +
((__t = (config['smallStyle'] && 'none')) == null ? '' : __t) +
'">' +
((__t = (templates[i].registrantOrganization)) == null ? '' : __t) +
'</td>\n					<td >\n						' +
((__t = (templates[i].email)) == null ? '' : __t) +
'\n						(\n							';
 if(templates[i].emailVerificationStatus) {;
__p += '\n							已验证\n							';
 }else{ ;
__p += '\n							<a href="//domain.console.aliyun.com/next/index#/email-verify?email=' +
((__t = (templates[i].email)) == null ? '' : __t) +
'" style="color:#00a2ca;text-decoration:none;" target="_blank">去验证</a>\n							';
 } ;
__p += '\n						)\n					</td>\n					';
if(!(config['auditStatus'] === false)){;
__p += '\n						<td style="width:120px;">\n							' +
((__t = (({FAILED:'审核失败',SUCCEED:'已实名认证',NONAUDIT:'未实名认证',AUDITING:'审核中'})[(templates[i].realNameStatus === undefined?"NONAUDIT":templates[i].realNameStatus)] || '')) == null ? '' : __t) +
'\n						</td>\n					';
};
__p += '\n\n					<td style="width:55px;"><a   class="view-detail" data-id="' +
((__t = (templates[i].registrantProfileId)) == null ? '' : __t) +
'">详情</a></td>\n				</tr>\n			     ';
};
__p += '\n				';
 if ( templates.length == 0){;
__p += '\n				<tr class="wait">\n					<td align="center" colspan="5">\n					<!--亲，没有查询到可用的信息模板，请您直接<a  class="add-template">填写域名信息</a>-->\n					亲，没有查询到可用的信息模板，请去<a href="//dc.console.aliyun.com/next/index?#/info-template/InfoTemplate" target="_blank">创建信息模版</a>。（转入域名时，必须使用已实名认证的模版）\n					</td>\n				</tr>\n				';
};
__p += '\n			';
}};
__p += '\n\n			</tbody>\n		</table>\n		';
 if (foldClose && totalpage>1) {;
__p += '\n			<div class="pagination">\n					<li><a href="javascript:;" class="current-page" value="' +
((__t = (1)) == null ? '' : __t) +
'">«</a></li>\n					';
 if (currentpage != 1) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage-1)) == null ? '' : __t) +
'">‹</a></li>\n					';
};
__p += '\n					';
 for(var i=currentpage-1; i <= (currentpage+2); i++) {;
__p += '\n						';
 if (i > 0&&i != currentpage && i <= totalpage) {;
__p += '\n							<li><a href="javascript:;" class="current-page" value="' +
((__t = (i)) == null ? '' : __t) +
'">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n						';
 }else if(i > 0&&i == currentpage && i <= totalpage){ ;
__p += '\n							<li><a href="javascript:;" class="current-page active" value="' +
((__t = (i)) == null ? '' : __t) +
'">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n						';
};
__p += '\n					';
};
__p += '\n					';
 if (currentpage == 1 && currentpage+3 <= totalpage) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage+3)) == null ? '' : __t) +
'">' +
((__t = (currentpage+3)) == null ? '' : __t) +
'</a></li>\n					';
};
__p += '\n					';
 if (currentpage != totalpage) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage+1)) == null ? '' : __t) +
'">›</a></li>\n					';
};
__p += '\n					<li><a href="javascript:;" class="current-page" value="' +
((__t = (totalpage)) == null ? '' : __t) +
'">»</a></li>\n				</div>\n			';
} else {;

};
__p += '\n		<div class="clear"></div>\n	<div class="fold-list-block">\n		<a class="fold-list">';
 if (foldClose) {;
__p += '收起';
} else {;
__p += '显示更多';
};
__p += '</a>\n	</div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/contactList/list.ejs
// module id = 97
// module chunks = 0